import { PropiedadesView } from 'features/projects';

const PropiedadesPage = () => <PropiedadesView />;

export default PropiedadesPage;
